import { ApolloError } from '@apollo/client';
import { Card, CardContent, Grid } from '@mui/material';

import { Typography, CircularProgress, LinearProgress, InfoField } from '@occc-app/design-system';
import { BannerConfigurationFragment, DisplayCategoryFragment } from '@occc/graphql';
import {
  mapBannersIdsToBannerTitleList,
  getLoadingBehaviorLabel,
} from '@occc-app/routes/DisplayCategory/utils';
import config from '@occc/config';

interface DisplayCategoryDetailsProps {
  loading: boolean;
  error?: ApolloError;
  displayCategory?: DisplayCategoryFragment | null;
  externalBanners?: BannerConfigurationFragment[] | null;
}

export const DisplayCategoryDetails = ({
  loading,
  error,
  displayCategory,
  externalBanners,
}: DisplayCategoryDetailsProps) => {
  if (error) {
    return <Typography color='error'>Something went wrong. Please try again.</Typography>;
  }
  if (loading && !displayCategory) {
    return <CircularProgress />;
  }
  if (!displayCategory) {
    return <Typography color='error'>No data. Something went wrong. Please try again.</Typography>;
  }

  return (
    <Card>
      {loading && <LinearProgress />}
      <CardContent>
        <Typography variant='h6'>General Details</Typography>
        <Grid container spacing={3} pt={3}>
          <Grid item xs={12} md={4}>
            <InfoField label='Name' value={displayCategory.name} mb={0} />
          </Grid>
          <Grid item xs={12} md={4}>
            <InfoField label='Restriction' value={displayCategory.categoryRestrictions} mb={0} />
          </Grid>
          <Grid item xs={12} md={4}>
            <InfoField label='Rank' value={displayCategory.rank} mb={0} />
          </Grid>
          {config.features.externalBannersEnabled && (
            <Grid item xs={12} md={12}>
              <InfoField
                label='External Source'
                value={mapBannersIdsToBannerTitleList({
                  bannerList: externalBanners,
                  selectedBannersIds: displayCategory?.bannerIds,
                })}
              />
            </Grid>
          )}
          {config.features.externalBannersEnabled &&
            (displayCategory.bannerIds?.length ?? 0) > 0 && (
              <Grid item xs={12} md={4}>
                <InfoField
                  label='Loading behavior'
                  value={getLoadingBehaviorLabel(displayCategory.shouldLazyLoadBanners)}
                  mb={0}
                />
              </Grid>
            )}
        </Grid>
      </CardContent>
    </Card>
  );
};
